import { render, staticRenderFns } from "./QiyeBang.vue?vue&type=template&id=53a3f6b6"
import script from "./QiyeBang.vue?vue&type=script&lang=js"
export * from "./QiyeBang.vue?vue&type=script&lang=js"
import style0 from "./QiyeBang.vue?vue&type=style&index=0&id=53a3f6b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports